<template>
  <client-only>
    <cms-pop-up-manager />
  </client-only>

  <div
    v-if="isPreview && netlifyDeployContext === 'deploy-preview' && show"
    class="fixed left-0 top-0 flex items-center gap-1 bg-red-60 p-1"
    style="z-index: 10002"
  >
    <span>PR preview: {{ previewId }}</span>
    <base-button aria-label="Hide PR preview ID" @click="show = false">
      <vf-icon name="close" />
    </base-button>
  </div>

  <transition v-if="isPreview" mode="in-out" name="fade">
    <vf-loader
      v-if="showPreviewUpdateIndicator"
      class="fixed right-0 top-0 z-above-header m-4 h-20 rounded-xl bg-green-30 bg-opacity-70 c-white"
      style="z-index: 800;"
    />
  </transition>

  <client-only>
    <lazy-app-espot-navigator v-if="isPreview && isEspot" />
  </client-only>
</template>

<script lang="ts" setup>
const { netlifyDeployContext, netlifyDeployUrl } = useRuntimeConfig().public
const { isPreview, isEspot, showPreviewUpdateIndicator, triggerPreviewUpdateIndicator } = useCms()
const router = useRouter()

const previewId = netlifyDeployUrl.match(/deploy-preview-(\d+)/)?.[1]

const show = ref(true)

useEventListener('message', async ({ data, origin }: MessageEvent) => {
  const isStudio = [origin, '*'].includes(window.com_coremedia_pbe_studioUrl)
  const isPreviewPage = router.currentRoute.value.name === 'cms-preview'
  const isAuthorablePage = router.currentRoute.value.name === 'content-slug'
  if (!isStudio || isPreviewPage || isAuthorablePage) return
  try {
    const message = isString(data) ? JSON.parse(data) : data

    if (message.type === 'updatePreview') {
      router.go(0)
      nextTick(() => triggerPreviewUpdateIndicator())
    }

    if (!['placements.addHighlight', 'placements.removeHighlight'].includes(message.type)) return
    isEspot.value = message.type === 'placements.addHighlight'
  }
  catch (error: any) {
    log.error('Failed to parse message data', error)
  }
})
</script>
